<div class="flex h-full flex-col">
  <div
    class="rug-loader-container flex h-1 grow flex-col gap-8 overflow-y-auto p-8">
    <router-outlet class="hidden"></router-outlet>
  </div>
</div>

<div class="hidden">
  <p-select></p-select>
  <p-button></p-button>
  <p-table [paginator]="true"></p-table>
  <input pInputText />
  <textarea pTextarea></textarea>>
  <p-popover></p-popover>
  <p-chip></p-chip>
  <p-toast></p-toast>
  <p-checkbox></p-checkbox>
  <p-progress-spinner></p-progress-spinner>
  <form [formGroup]="form">
    <p-radiobutton formControlName="radiobutton"></p-radiobutton>
    <p-datepicker formControlName="datepicker"></p-datepicker>
  </form>
  <p-selectbutton
    [options]="routes"
    [ngModel]="value()"
    optionLabel="label"
    optionValue="value" />
  <p-tag severity="info" value="Info" [rounded]="true"></p-tag>
  <p-inputgroup>
    <p-inputgroup-addon> </p-inputgroup-addon>
  </p-inputgroup>
  <p-fileupload
    #fu
    mode="basic"
    chooseLabel="Choose"
    name="demo[]"
    accept="image/*"
    maxFileSize="1" />
  <p-multiselect
    [options]="[]"
    [(ngModel)]="multiselect"
    placeholder="Select one"
    optionLabel="multiselect"
    display="chip" />
  <p-paginator
    [first]="1"
    [rows]="4"
    [totalRecords]="20"
    [rowsPerPageOptions]="[4, 8, 12]"></p-paginator>
  <p-accordion value="0">
    <p-accordion-panel value="0">
      <p-accordion-header>Header I</p-accordion-header>
      <p-accordion-content>
        <p class="m-0">0</p>
      </p-accordion-content>
    </p-accordion-panel>

    <p-accordion-panel value="1">
      <p-accordion-header>Header II</p-accordion-header>
      <p-accordion-content>
        <p class="m-0">1</p>
      </p-accordion-content>
    </p-accordion-panel>
  </p-accordion>

  <p-tabs value="0">
    <p-tablist>
      <p-tab value="0">Header I</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        <p class="m-0">Panel 0</p>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
